// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__5aLii","col":"styles_col__3Hv1t","fulfillmentStatus":"styles_fulfillmentStatus__SqvuX","emailCol":"styles_emailCol__2Pn11"};